import MachineImg1 from "../../../../assets/images/Windscreen.png";
import MachineImg2 from "../../../../assets/png/ENGINEERING.jpg";
import MachineImg3 from "../../../../assets/png/bulldozer4.png";
import MachineImg4 from "../../../../assets/images/nz-img-4.png";
import { useNavigate } from "react-router";
import { NZRouterPaths } from "../../../../router/router";
import StarIcon from "../../../../assets/svg/star-fill.svg";
const NZTutaraOption = () => {
  let navigate = useNavigate();
  return (
    <div className="pt-[86px] pb-[65px] bg-[#f7f7f7]">
      <div className="md:max-w-[80%] max-w-full mx-auto py-[30px]">
        <div className="custom-container px-[30px] text-center">
          <div className="font-Teko 2xl:text-[62px] lg:text-[66px] md:text-[55px] text-[55px] font-semibold	lg:mb-[40px] sm:mb-[20px] mb-[10px] text-[#333] leading-[1em]  kuunari-bold">
            PURCHASE THE MOST VERSATILE SIDE-BY-SIDE
          </div>
          <p className="font-lato  text-[16px] montserrat-medium  text-[#333] leading-[1.8em] lg:mb-[40px] sm:mb-[20px] mb-[10px]">
            Our ATV side-by-side vehicles (Electric and Petrol) are purpose-built for off-road running and designed
            specially to be every farmer’s primary workhorse, but the real strength of the Tuatara UTV is its
            versatility, making it ideal for a wide range of activities, including farming, horticulture, agricultural
            contracting, hunting, golf courses, retirement villages, mining, zoos, district council ground works,
            airports, power stations, civil construction, fighting forest fires… and the list goes on. We know this
            because we have supplied Tuataras to every one of the occupations listed.
          </p>
          <p className="font-lato  text-[16px] montserrat-medium text-[#333] leading-[1.8em] lg:mb-[40px] sm:mb-[20px] mb-[10px]">
            Reliability and low maintenance is the name of the game and you need not look any further than the Tuatara
            to meet these requirements and while the Tuatara is often categorised as an ATV, it is more correctly an
            off-road utility vehicle (UTV) because frankly the Tuatara will go where the others can’t, and it will carry
            more and tow more than its rivals, if it has any.
          </p>
          <p className="flex flex-wrap justify-center mt-4 gap-4 sm:grid sm:grid-cols-2 lg:flex lg:flex-row">
            {["Powerful", "Go Anywhere", "Versatile", "Low Maintenance"].map((text, index) => (
              <span key={index} className="flex items-center gap-2 text-[16px] leading-[24px]">
                <img src={StarIcon} alt="" className="w-4 h-4" />
                {text}
              </span>
            ))}
          </p>
        </div>
      </div>
      <div className="custom-container py-[30px]">
        <h3 className="font-Teko text-center text-[35px] text-[#333] leading-[1em] mb-[30px] kuunari-bold">
          2025 Models
        </h3>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-3">
          <div className="col-span-1 flex flex-col items-center justify-between">
            <div className="flex flex-col w-full h-full justify-center">
              <img src={MachineImg1} alt="" className="h-full object-cover w-full" />
              <h2 className="font-Teko text-center text-[30px] text-[#333] leading-[1em] mt-[20px]">Petrol Model</h2>
              {/* <p className="text-center text-[#333] text-[16px] leading-[25px] montserrat-medium">
                Check out the latest <b>Petrol Tuatara ATV</b> side by side model.
              </p> */}
            </div>
            <div className=" mb-[30px] flex justify-center align-items-center">
              <div
                className="bg-[#af8600] montserrat-medium text-center text-[16px] text-white leading-[40px] px-[16px] py-[5px] cursor-pointer mt-[20px]"
                onClick={() => {
                  navigate(NZRouterPaths.Petrol);
                }}
              >
                LEARN MORE
              </div>
            </div>
          </div>
          <div className="col-span-1 flex flex-col items-center justify-between">
            <div className="flex flex-col w-full h-full justify-center">
              <img src={MachineImg2} alt="" className="h-full object-cover w-full" />
              <h2 className="font-Teko text-center text-[30px] text-[#333] leading-[1em] mt-[20px]">Electric Model</h2>
              {/* <p className="text-center text-[#333] text-[16px] leading-[25px] montserrat-medium">
                The e<b>TUATARA Electric ATV</b> is unquestionably the <b>Market Leader</b> by a country mile. No
                off-road EV side-by-side can come close!
              </p> */}
            </div>
            <div className="mb-[30px] flex justify-center align-items-center">
              <div
                className="bg-[#af8600] montserrat-medium text-center text-[16px] text-white leading-[40px] px-[16px] py-[5px] cursor-pointer mt-[20px]"
                onClick={() => {
                  navigate(NZRouterPaths.ElectricAccessories);
                }}
              >
                LEARN MORE
              </div>
            </div>
          </div>
          <div className="col-span-1 flex flex-col items-center justify-between">
            <div className="flex flex-col w-full h-full justify-center">
              <img src={MachineImg3} alt="" className="h-full object-cover w-full" />
              <h2 className="font-Teko text-center text-[30px] text-[#333] leading-[1em] mt-[20px]">
                Dual Motor / Dual Cabin (Electric)
              </h2>
              {/* <p className="text-center text-[#333] text-[16px] leading-[25px] montserrat-medium">
                Our <b>ATV accessories</b> include an:{" "}
                <b>ATV Trailer, lightweight ATV Cage, Glass Windscreen Back window, Full doors or half doors.</b>
              </p> */}
            </div>
            <div className="mb-[30px] flex justify-center align-items-center">
              <div
                className="bg-[#af8600] montserrat-medium text-center text-[16px] text-white leading-[40px] px-[16px] py-[5px] cursor-pointer mt-[20px]"
                onClick={() => {
                  navigate(NZRouterPaths.ElectricDualMotor);
                }}
              >
                LEARN MORE
              </div>
            </div>
          </div>
          <div className="col-span-1 flex flex-col items-center justify-between">
            <div className="flex flex-col w-full h-full justify-center">
              <img src={MachineImg4} alt="" className="h-full object-cover w-full" />
              <h2 className="font-Teko text-center text-[30px] text-[#333] leading-[1em] mt-[20px]">
                Orchardised (Electric)
              </h2>
              {/* <p className="text-center text-[#333] text-[16px] leading-[25px] montserrat-medium">
                Our <b>ATV accessories</b> include an:{" "}
                <b>ATV Trailer, lightweight ATV Cage, Glass Windscreen Back window, Full doors or half doors.</b>
              </p> */}
            </div>
            <div className="mb-[30px] flex justify-center align-items-center">
              <div
                className="bg-[#af8600] montserrat-medium text-center text-[16px] text-white leading-[40px] px-[16px] py-[5px] cursor-pointer mt-[20px]"
                onClick={() => {
                  navigate(NZRouterPaths.Orchardised);
                }}
              >
                LEARN MORE
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NZTutaraOption;
